import React from "react";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const DropdownIndicator = (props) => {
  return <ArrowDropDownIcon style={{ color: "#ccc" }} />;
};

export default DropdownIndicator;
